import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-info-row',
	standalone: true,
	templateUrl: './xp-info-row.component.html',
	styleUrls: ['./xp-info-row.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpInfoRowComponent {
	label = input('');
}
